import React, { Component } from "react";
import { MDBRow, MDBCol, MDBContainer, MDBCard, MDBCardBody, MDBCardTitle, MDBCardText } from "mdbreact";
import axios from "axios";
import MetaTags from "react-meta-tags";
import packkagee from "../../../package.json";

export default class Insertpresent5 extends Component {

    constructor(props) {
        super(props)
        this.state = {
            REGISTER_ID: null,
            WORKINGSTATUS: "N",
            WORKBUSINESS: null,
            WORKSALARY: null,
            WORKNAME: null,
            NUM_W: null,
            MOO_W: null,
            SOI_W: null,
            STREET_W: null,
            SUBDISTRICT: null,
            TUMBOL_W: null,
            AMPHUR_W: null,
            PROVINCE_W: null,
            ZIPCODE_W: null,
            PHONE_W: null,

            array_province: [],
            array_district: [],
            array_sub_district: [],
        }
        this.handleProvinceChange = this.handleProvinceChange.bind(this);
        this.handleDistrictChange = this.handleDistrictChange.bind(this);
        this.handleSubDistrictChange = this.handleSubDistrictChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        axios.get("https://admission.kpru.ac.th/admission2017/student/loadpresent/" + localStorage.getItem("ID_LOGIN")).then((respone) => {
        // axios.get("https://git.kpru.ac.th/admission2017/student/loadpresent/" + localStorage.getItem("ID_LOGIN")).then((respone) => {
            respone.data = respone.data.filter(({ REGISTER_STATUS }) => !(REGISTER_STATUS === "11"));
            this.setState({ REGISTER_ID: respone.data[0]["REGISTER_ID"] });
            // axios.get("https://git.kpru.ac.th/admission2017/student_insertpresent5/profilework/"+respone.data[0]["REGISTER_ID"]).then((res) => {
            axios.get("https://admission.kpru.ac.th/admission2017/student_insertpresent5/profilework/" + respone.data[0]["REGISTER_ID"]).then((res) => {
                if (res.data.length !== 0) {
                    if (res.data[0]["WORKINGSTATUS"]) {
                        this.setState({ WORKINGSTATUS: res.data[0]["WORKINGSTATUS"] });
                        if (res.data[0]["WORKINGSTATUS"] === "Y") {
                            let headers = new Headers({ "Content-Type": "application/x-www-form-urlencoded" });
                            axios.post("https://mua.kpru.ac.th/FrontEnd_Admission/admission/district_register/", { provincy_study: res.data[0]["PROVINCE_W"] }, { headers: headers }).then((district) => {
                                this.setState({ array_district: district.data });
                            })
                            axios.post("https://mua.kpru.ac.th/FrontEnd_Admission/admission/subdistrict_register/", { district_study: res.data[0]["AMPHUR_W"] }, { headers: headers }).then((sub_district) => {
                                this.setState({ array_sub_district: sub_district.data });
                            })
                        }
                    } else {
                        this.setState({ WORKINGSTATUS: "N" });
                    }
                    this.setState({ WORKBUSINESS: res.data[0]["WORKBUSINESS"] });
                    this.setState({ WORKSALARY: res.data[0]["WORKSALARY"] });
                    this.setState({ WORKNAME: res.data[0]["WORKNAME"] });
                    this.setState({ NUM_W: res.data[0]["NUM_W"] });
                    this.setState({ MOO_W: res.data[0]["MOO_W"] });
                    this.setState({ SOI_W: res.data[0]["SOI_W"] });
                    this.setState({ STREET_W: res.data[0]["STREET_W"] });
                    this.setState({ SUBDISTRICT: res.data[0]["TUMBOL_W"] + "," + res.data[0]["ZIPCODE_W"] });
                    this.setState({ TUMBOL_W: res.data[0]["TUMBOL_W"] });
                    this.setState({ AMPHUR_W: res.data[0]["AMPHUR_W"] });
                    this.setState({ PROVINCE_W: res.data[0]["PROVINCE_W"] });
                    this.setState({ ZIPCODE_W: res.data[0]["ZIPCODE_W"] });
                    this.setState({ PHONE_W: res.data[0]["PHONE_W"] });
                }
            })
        })
        axios.get("https://mua.kpru.ac.th/FrontEnd_Admission/admission/province_register/").then((province) => {
            this.setState({ array_province: province.data });
        })
    }

    handleProvinceChange(event) {
        this.setState({ [event.target.name]: event.target.value });
        let headers = new Headers({ "Content-Type": "application/x-www-form-urlencoded" });
        axios.post("https://mua.kpru.ac.th/FrontEnd_Admission/admission/district_register/", { provincy_study: event.target.value }, { headers: headers }).then((district) => {
            this.setState({ array_district: district.data });
        })
    }

    handleDistrictChange(event) {
        this.setState({ [event.target.name]: event.target.value });
        let headers = new Headers({ "Content-Type": "application/x-www-form-urlencoded" });
        axios.post("https://mua.kpru.ac.th/FrontEnd_Admission/admission/subdistrict_register/", { district_study: event.target.value }, { headers: headers }).then((sub_district) => {
            this.setState({ array_sub_district: sub_district.data });
        })
    }

    handleSubDistrictChange(event) {
        var spitsubdistrict = event.target.value.split(",");
        if (spitsubdistrict !== "") {
            this.setState({ [event.target.name]: event.target.value });
            this.setState({ TUMBOL_W: spitsubdistrict[0] });
            this.setState({ ZIPCODE_W: spitsubdistrict[1] });
        }
    }

    handleChange(event) {
        this.setState({ [event.target.name]: event.target.value });
    }

    handleClick(event) {
        this.setState({ [event.target.name]: event.target.value });
    }

    handleSubmit(event) {
        event.preventDefault();
        let bodydata = {
            REGISTER_ID: this.state.REGISTER_ID,
            WORKINGSTATUS: this.state.WORKINGSTATUS,
            WORKBUSINESS: this.state.WORKBUSINESS,
            WORKSALARY: this.state.WORKSALARY,
            WORKNAME: this.state.WORKNAME,
            NUM_W: this.state.NUM_W,
            MOO_W: this.state.MOO_W,
            SOI_W: this.state.SOI_W,
            STREET_W: this.state.STREET_W,
            TUMBOL_W: this.state.TUMBOL_W,
            AMPHUR_W: this.state.AMPHUR_W,
            PROVINCE_W: this.state.PROVINCE_W,
            ZIPCODE_W: this.state.ZIPCODE_W,
            PHONE_W: this.state.PHONE_W,
        }
        // axios.post("https://git.kpru.ac.th/admission2017/student_insertpresent5/updatepresent/"+this.state.REGISTER_ID, bodydata).then((data) => {
        axios.post("https://admission.kpru.ac.th/admission2017/student_insertpresent5/updatepresent/" + this.state.REGISTER_ID, bodydata).then((data) => {
            window.location.href = "/" + packkagee.name + "/Insertpresent6";
        })
    }

    render() {
        return (<>
            <MetaTags>
                <title>ข้อมูลการมีงานทำ มหาวิทยาลัยราชภัฏกำแพงเพชร</title>
                <meta name="description" content="ข้อมูลการมีงานทำ มหาวิทยาลัยราชภัฏกำแพงเพชร Kamphaeng Phet Rajabhat University" />
                <meta property="og:title" content="ข้อมูลการมีงานทำ มหาวิทยาลัยราชภัฏกำแพงเพชร" />
                <meta property="og:image" content="../../public/favicon.ico" />
            </MetaTags>
            <br />
            <MDBContainer fluid>
                <h4>ข้อมูลรายงานตัว มหาวิทยาลัยราชภัฏกำแพงเพชร</h4>
                <form onSubmit={this.handleSubmit}>

                    <MDBRow>
                        <MDBCol lg="1" md="0" sm="0"></MDBCol>
                        <MDBCol lg="10" md="12" sm="12">
                            <MDBCard>
                                <MDBCardBody>
                                    <MDBContainer fluid>
                                        <MDBRow>
                                            <MDBCol>
                                                <MDBCardTitle>
                                                    ข้อมูลการมีงานทำ
                                                </MDBCardTitle>
                                                <MDBCardText>
                                                    <span className="text-danger">* จำเป็นต้องกรอกข้อมูล</span>
                                                    <MDBRow className="mt-2">
                                                        <MDBCol lg="3" md="12" sm="12">
                                                            <div className="form-outline mt-2">
                                                                <label className="form-label" for="WORKINGSTATUS2">สถานะการทำงาน  <span className="text-danger">*</span></label><br />
                                                                <div className="form-check form-check-inline">
                                                                    <input className="form-check-input" type="radio" name="WORKINGSTATUS" id="WORKINGSTATUS1" onClick={this.handleClick} value="N" checked={this.state.WORKINGSTATUS === "N" ? true : false} />
                                                                    <label className="form-check-label" for="WORKINGSTATUS1">ยังไม่มีงานทำ</label>
                                                                </div>
                                                                <div className="form-check form-check-inline">
                                                                    <input className="form-check-input" type="radio" name="WORKINGSTATUS" id="WORKINGSTATUS2" onClick={this.handleClick} value="Y" checked={this.state.WORKINGSTATUS === "Y" ? true : false} />
                                                                    <label className="form-check-label" for="WORKINGSTATUS2">ทำงานแล้ว</label>
                                                                </div>
                                                            </div>
                                                        </MDBCol>
                                                        {this.state.WORKINGSTATUS === "Y" ? <>
                                                            <MDBCol lg="3" md="4" sm="12">
                                                                <div className="form-outline mt-2">
                                                                    <label className="form-label" for="WORKBUSINESS">ตำแหน่งงาน <span className="text-danger">*</span></label>
                                                                    <input type="text" className="form-control" id="WORKBUSINESS" name="WORKBUSINESS" value={this.state.WORKBUSINESS} onChange={this.handleChange} required />
                                                                </div>
                                                            </MDBCol>
                                                            <MDBCol lg="3" md="4" sm="12">
                                                                <div className="form-outline mt-2">
                                                                    <label className="form-label" for="WORKSALARY">เงินเดือน <span className="text-danger">*</span></label>
                                                                    <input type="text" className="form-control" id="WORKSALARY" name="WORKSALARY" value={this.state.WORKSALARY} onChange={this.handleChange} required />
                                                                </div>
                                                            </MDBCol>
                                                            <MDBCol lg="3" md="4" sm="12">
                                                                <div className="form-outline mt-2">
                                                                    <label className="form-label" for="PHONE_W">เบอร์โทรศัพท์ <span className="text-danger">*</span></label>
                                                                    <input type="tel" className="form-control" id="PHONE_W" name="PHONE_W" value={this.state.PHONE_W} onChange={this.handleChange} maxLength="10" required />
                                                                </div>
                                                            </MDBCol>
                                                            <MDBCol lg="4" md="12" sm="12">
                                                                <div className="form-outline mt-2">
                                                                    <label className="form-label" for="WORKNAME">ชื่อหน่วยงาน/สถานทีทำงาน <span className="text-danger">*</span></label>
                                                                    <input type="text" className="form-control" id="WORKNAME" name="WORKNAME" value={this.state.WORKNAME} onChange={this.handleChange} required />
                                                                </div>
                                                            </MDBCol>
                                                            <MDBCol lg="2" md="6" sm="12">
                                                                <div className="form-outline mt-2">
                                                                    <label className="form-label" for="NUM_W">บ้านเลขที่ <span className="text-danger">*</span></label>
                                                                    <input type="text" className="form-control" id="NUM_W" name="NUM_W" value={this.state.NUM_W} onChange={this.handleChange} required />
                                                                </div>
                                                            </MDBCol>
                                                            <MDBCol lg="2" md="6" sm="12">
                                                                <div className="form-outline mt-2">
                                                                    <label className="form-label" for="MOO_W">หมู่ที่ <span className="text-danger">*</span></label>
                                                                    <input type="text" className="form-control" id="MOO_W" name="MOO_W" value={this.state.MOO_W} onChange={this.handleChange} required />
                                                                </div>
                                                            </MDBCol>
                                                            <MDBCol lg="2" md="6" sm="12">
                                                                <div className="form-outline mt-2">
                                                                    <label className="form-label" for="SOI_W">ซอย <span className="text-danger">หากไม่มีให้ใส่ -</span></label>
                                                                    <input type="text" className="form-control" id="SOI_W" name="SOI_W" value={this.state.SOI_W} onChange={this.handleChange} required />
                                                                </div>
                                                            </MDBCol>
                                                            <MDBCol lg="2" md="6" sm="12">
                                                                <div className="form-outline mt-2">
                                                                    <label className="form-label" for="STREET_W">ถนน <span className="text-danger">หากไม่มีให้ใส่ -</span></label>
                                                                    <input type="text" className="form-control" id="STREET_W" name="STREET_W" value={this.state.STREET_W} onChange={this.handleChange} required />
                                                                </div>
                                                            </MDBCol>
                                                            <MDBCol lg="3" md="6" sm="12">
                                                                <div className="form-outline mt-2">
                                                                    <label className="form-label" for="PROVINCE_W">จังหวัด <span className="text-danger">*</span></label>
                                                                    <select className="form-control" id="PROVINCE_W" name="PROVINCE_W" onChange={this.handleProvinceChange} required >
                                                                        <option value="" hidden>ระบุจังหวัด</option>
                                                                        {this.state.array_province.map((data) => {
                                                                            return data.PROVINCE_ID === this.state.PROVINCE_W ? <>
                                                                                <option value={data.PROVINCE_ID} selected>{data.PROVINCE_NAME_TH}</option>
                                                                            </> : <>
                                                                                <option value={data.PROVINCE_ID}>{data.PROVINCE_NAME_TH}</option>
                                                                            </>
                                                                        })}
                                                                    </select>
                                                                </div>
                                                            </MDBCol>
                                                            <MDBCol lg="3" md="6" sm="12">
                                                                <div className="form-outline mt-2">
                                                                    <label className="form-label" for="AMPHUR_W">อำเภอ/เขต <span className="text-danger">*</span></label>
                                                                    <select className="form-control" id="AMPHUR_W" name="AMPHUR_W" onChange={this.handleDistrictChange} required >
                                                                        <option value="" hidden>ระบุอำเภอ</option>
                                                                        {this.state.array_district.map((data) => {
                                                                            return data.DISTRICT_ID === this.state.AMPHUR_W ? <>
                                                                                <option value={data.DISTRICT_ID} selected>{data.DISTRICT_NAME_TH}</option>
                                                                            </> : <>
                                                                                <option value={data.DISTRICT_ID}>{data.DISTRICT_NAME_TH}</option>
                                                                            </>
                                                                        })}
                                                                    </select>
                                                                </div>
                                                            </MDBCol>
                                                            <MDBCol lg="3" md="6" sm="12">
                                                                <div className="form-outline mt-2">
                                                                    <label className="form-label" for="SUBDISTRICT">ตำบล/แขวง <span className="text-danger">*</span></label>
                                                                    <select className="form-control" id="SUBDISTRICT" name="SUBDISTRICT" onChange={this.handleSubDistrictChange} required >
                                                                        <option value="" hidden>ระบุตำบล</option>
                                                                        {this.state.array_sub_district.map((data) => {
                                                                            return (data.SUB_DISTRICT_ID + "," + data.ZIPCODE) === this.state.SUBDISTRICT ? <>
                                                                                <option value={data.SUB_DISTRICT_ID + "," + data.ZIPCODE} selected>{data.SUB_DISTRICT_NAME_TH}</option>
                                                                            </> : <>
                                                                                <option value={data.SUB_DISTRICT_ID + "," + data.ZIPCODE}>{data.SUB_DISTRICT_NAME_TH}</option>
                                                                            </>
                                                                        })}
                                                                    </select>
                                                                </div>
                                                            </MDBCol>
                                                            <MDBCol lg="3" md="6" sm="12">
                                                                <div className="form-outline mt-2">
                                                                    <label className="form-label" for="ZIPCODE_W">รหัสไปรษณีย์</label>
                                                                    <input type="text" className="form-control" id="ZIPCODE_W" name="ZIPCODE_W" maxlength="5" value={this.state.ZIPCODE_W} disabled required />
                                                                </div>
                                                            </MDBCol>
                                                        </> : <></>}
                                                    </MDBRow>

                                                </MDBCardText>
                                            </MDBCol>
                                        </MDBRow>
                                        {this.state.WORKINGSTATUS === "Y" ? <>
                                            {this.state.WORKBUSINESS && this.state.WORKSALARY && this.state.PHONE_W && this.state.WORKNAME && this.state.NUM_W && this.state.MOO_W && this.state.SOI_W &&
                                                this.state.STREET_W && this.state.PROVINCE_W && this.state.AMPHUR_W && this.state.SUBDISTRICT && this.state.ZIPCODE_W ? <>
                                                <button type="submit" className="btn btn-primary btn-rounded btn-md mt-2">บันทึกข้อมูล</button>
                                            </> : <>
                                                <button type="submit" className="btn btn-primary btn-rounded btn-md mt-2" disabled>บันทึกข้อมูล</button>
                                            </>}
                                        </> : <>
                                            <button type="submit" className="btn btn-primary btn-rounded btn-md mt-2">บันทึกข้อมูล</button>
                                        </>}
                                    </MDBContainer>
                                </MDBCardBody>
                            </MDBCard>
                        </MDBCol>
                        <MDBCol lg="1" md="0" sm="0"></MDBCol>
                    </MDBRow>
                </form>
            </MDBContainer>
        </>)
    }
}